<div id="trackers-wrapper">
  <div id="trackers-table-header-wrapper">
    <span id="events-header" class="tracker-title">Type d’événement</span>
    <span id="trackers-header" class="tracker-title" *ngIf="trackers">
      <i-bs class="mr5px" name="info-circle-fill" width="16" height="16"
            [tooltip]="'Chaque type d’événement peut contenir jusqu’à ' + maxTrackers + ' trackers. Ils seront visibles par le ou la patient.e lors de la création d’un événement depuis leur application mobile.'"
            container="body" placement="bottom"></i-bs>
      Trackers {{ getOrigin(trackers.origin) }}
    </span>
  </div>
  <div id="trackers-table" *ngIf="trackers && events && selectedTrackerType">
    <div id="events-list">
      <msd-event-cell (click)="changeTrackerType(event)"
                      (onEdit)="editDiaryType($event)"
                      (onMask)="maskDiaryType($event)"
                      *ngFor="let event of sortEvents(events)"
                      [activeTrackers]="activeTrackers?.[event.name]"
                      [class.active]="selectedTrackerType === event"
                      [loading]="loading"
                      [selectedType]="selectedTrackerType"
                      [trackers]="selectedTrackers(trackers.trackerCellModels, event)"
                      [type]="event">
      </msd-event-cell>
    </div>
    <div id="trackers-checker-wrapper">
      <div class="mention">Vous ne pouvez sélectionner que {{ maxTrackers }} trackers, par type d'événement.</div>
      <div *ngIf="!error && !loading && trackers; else innerLoading"
           [(dragulaModel)]="currentTrackers"
           [dragula]="'DRAG_TRACKERS'"
           class="drag-drop-zone"
           id="trackers-list">
        <ng-container *ngFor="let tracker of currentTrackers; let i = index">
          <msd-tracker-cell (deleteAction)="onDeleteTracker(tracker.entity)"
                            (editAction)="onEditTracker(tracker.entity)"
                            (toggle)="onTrackerToggle(tracker.entity, $event)"
                            [class.disabled]="!selectedTrackerType.displayed || (!isAllowedToActivate && !tracker.checked)"
                            [isNewPatientGroup]="isNewPatientGroup"
                            [tracker]="tracker"
                            [id]="tracker.entity.id.toString()">
          </msd-tracker-cell>
        </ng-container>
      </div>
      <ng-template #innerLoading>
        <ngx-inner-loading class="flex-center" [empty]="trackers && trackers.trackerCellModels.length <= 0"
                           [error]="error"
                           [loading]="loading"
                           [emptyDescription]="'Aucun tracker, vous pouvez en créer en cliquant sur le bouton ci-dessous'"
                           loadingDescription="Chargement..."
                           [errorDescription]="'Une erreur est survenue, veuillez réessayer plus tard.'"
                           retryButtonText="Réessayer">
        </ngx-inner-loading>
      </ng-template>

      <div id="trackers-footer" *ngIf="withNewTrackerButton">
        <button id="new-tracker-button" type="button" (click)="onNewTracker()"
                class="btn btn-outline btn-outline-primary text-icon">
          Nouveau tracker
          <i i-bs name="plus-square" width="15" height="15"></i>
        </button>
      </div>
    </div>
  </div>
</div>
